import { render, staticRenderFns } from "./NewDocumentDialog.vue?vue&type=template&id=753dca1a&scoped=true&"
import script from "./NewDocumentDialog.vue?vue&type=script&lang=js&"
export * from "./NewDocumentDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewDocumentDialog.vue?vue&type=style&index=0&id=753dca1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753dca1a",
  null
  
)

export default component.exports